import {IRawTranslationMessage, ITranslationMessage} from "./TranslationMessage";
import {IFeedback} from "./IFeedback";
import {IUserClick} from "./IUserClick";
import {IUserView} from "./IUserView";
import {IGroup} from "./IGroup";

export enum IMessageState {
    Draft = 0,
    Ready = 1,
    Sending = 2,
    Sent = 3,
    PrepareResending = 4,
    Planned = 5,
}

export enum ISendType {
    None = 0,
    EveryOne = 1,
    Group = 2,
    MailingList = 3,
}

export enum IMessageChannel {
    Channel_Teams = 0, Channel_Windows = 1, Channel_GPTPro = 2
}

export interface IRawMessage {
    id?: string,
    state: IMessageState,
    tenantId: string,
    translations: Array<IRawTranslationMessage>,
    topicsId: Array<string>,
    groupId: string,
    mailingListId?: string | undefined,
    sendType: ISendType,
    channel: IMessageChannel,
    gptId: string | undefined,
    authorName: string,
}

export interface IDraftMessage extends Omit<IRawMessage, "translations"> {
    group?: IGroup | undefined,
    mailingListId?: string | undefined,
    defaultLanguage: ITranslationMessage,
    translations: Array<ITranslationMessage>,
    authorName: string,
}

export interface ISentMessage extends IDraftMessage {
    sendingStart: string,
    sendingEnd: string,
    numberOfSuccess: number,
    numberOfFailure: number,
    numberToSend: number,
    numberToRead: number,
    feedbacks: Array<IFeedback>,
    userClicks: Array<IUserClick>,
    userViews: IUserView,
    authorName: string,
}

export type IMessage = IDraftMessage | ISentMessage;